import script from "./CarSignUpFormForJob.vue?vue&type=script&setup=true&lang=js"
export * from "./CarSignUpFormForJob.vue?vue&type=script&setup=true&lang=js"

import "./CarSignUpFormForJob.vue?vue&type=style&index=0&id=722e287b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722e287b"]])

export default __exports__